import { Box, MenuItem, Button } from "@mui/material"
import { StyledTextField } from "components/inputs/StyledTextField.tsx"
import { useForm, Controller } from "react-hook-form"
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { useEffect } from "react"

const filterFields = {
    vehicle: [
        {
            name: "licensePlate",
            id: "vehicle-page-licensePlate",
            label: "Plaque d'immatriculation",
        },
        {
            name: "description",
            id: "vehicles-page-description",
            label: "Description",
        },
        {
            name: "status",
            id: "vehicles-page-status",
            label: "Statut",
            select: true,
        },
    ],
    driver: [
        {
            name: "status",
            id: "drivers-page-status",
            label: "Statut",
            select: true,
        },
        {
            name: "lastName",
            id: "drivers-page-lastName",
            label: "Nom",
        },
        {
            name: "firstName",
            id: "drivers-page-firstName",
            label: "Prénom",
        },
        {
            name: "email",
            id: "drivers-page-email",
            label: "Email",
        },
    ],

}

export const CardHolderFilter = () => {
    const { onFilterSubmit, defaultFilterValues, isVehicle } =
        useCardHolderContext()
    const { control, handleSubmit, setValue } = useForm({
        defaultValues: defaultFilterValues,
    })
    const fields = isVehicle ? filterFields.vehicle : filterFields.driver

    const toKebabCase = (str: string): string => {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };
    useEffect(() => {
        if (!defaultFilterValues?.status) {
            setValue("status", "Tous")
        }
    }, [defaultFilterValues, setValue])

    return (
        <form onSubmit={handleSubmit(onFilterSubmit)}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    width: "100%",
                    height: "56px",
                }}
            >
                {fields.map(({ name, id, label, select }) => (
                    <Controller
                        key={name}
                        name={
                            name as
                                | "firstName"
                                | "lastName"
                                | "email"
                                | "status"
                                | "licensePlate"
                                | "description"
                        }
                        control={control}
                        render={({ field }) => (
                            <StyledTextField
                                id={id}
                                label={label}
                                select={select}
                                {...field}
                                data-cy={`side-bar__nav-${isVehicle ? "vehicle" : "drivers"}--${toKebabCase(name)}`}
                            >
                                <MenuItem
                                    value="Tous"
                                    data-cy={isVehicle ? "nav-vehicle__status--all" : "nav-drivers__status--all"}
                                >
                                    Tous
                                </MenuItem>
                                <MenuItem
                                    value="Actif"
                                    data-cy={isVehicle ? "nav-vehicle__status--active" : "nav-drivers__status--active"}
                                >
                                    Actif
                                </MenuItem>
                                <MenuItem
                                    value="Inactif"
                                    data-cy={isVehicle ? "nav-vehicle__status--unactive" : "nav-drivers__status--unactive"}
                                >
                                    Inactif
                                </MenuItem>
                            </StyledTextField>
                        )}
                    />
                ))}
                <Button
                    data-testid="FilterSubmit"
                    data-cy={isVehicle ? "side-bar__nav-vehicle--submit" : "side-bar__nav-drivers--submit"}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                        minWidth: "56px",
                        height: "56px",
                        aspectRatio: "1/1",
                        borderRadius: "10px",
                        "&:hover, &:focus": {
                            backgroundColor: "primary.hover",
                        },
                    }}
                >
                    <SearchOutlinedIcon
                        sx={{ color: "white", fontSize: "2rem" }}
                    />
                </Button>
            </Box>
        </form>
    )
}
